import {Injectable, Injector} from "@angular/core";
import {SearchModel} from "@fedeltapointofsale/data-client";
import {GroupedOutletCustomData} from "./grouped-outlet-custom.data";

/**
 * Search model for Inventory
 */
@Injectable()
export class GroupedOutletCustomSearchModel extends SearchModel<GroupedOutletCustomData> {

    constructor(injector: Injector) {
        super(injector);
    }
}
